import React from "react";
import splashImg from "../../assets/splash_img.png";
import logoImg from "../../assets/logo_svg.svg";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../components/button/CustomButton";

export const Splash = () => {
  const navigate = useNavigate();
  const handleNavigate = (key) => {
    navigate(key);
  }
  return (
    <div className="h-screen w-full">
      <div
        className="h-full w-full flex items-center justify-center bg-cover bg-center px-4"
        style={{ backgroundImage: `url(${splashImg})` }}
      >
        <div className="flex bg-white w-full max-w-[635px] sm:min-h-[484px] py-8  sm:py-16  px-5 sm:px-8 rounded-3xl shadow-lg">
          <div className="flex flex-col items-center justify-between w-full gap-10">
            {/* Logo */}
            <div className="w-56 h-56">
              <img
                src={logoImg}
                alt="Loading"
                className="w-full h-full object-contain"
              />
            </div>
            <div className="flex flex-col items-center gap-4 w-full">
              <CustomButton text="Get Started" onClick={() =>handleNavigate('/user-type')} className="py-1" />
              <button 
                onClick={() =>handleNavigate('/login')}
                className="text-primary hover:underline text-sm sm:text-base"
              >
                Already have an account? Sign In
              </button>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};
